import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { InsertVariableDialogComponent, InsertVariableDialogData } from '@portal-core/project-files/variables/components/insert-variable-dialog/insert-variable-dialog.component';
import { XmlProjectVariableDefinition } from '@portal-core/project-files/variables/viewmodels/project-variable-definition.model';
import { first } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VariablesInsertService {
  constructor(
    private dialog: MatDialog
  ) { }

  insertVariable(data: InsertVariableDialogData, input: HTMLInputElement, form: UntypedFormGroup) {
    this.dialog.open<InsertVariableDialogComponent, InsertVariableDialogData, string>(InsertVariableDialogComponent, {
      ...InsertVariableDialogComponent.DialogConfig,
      data: data
    })
      .afterClosed().pipe(first()).subscribe((variableName: string) => {
        if (variableName) {
          let selStart: number = input.selectionStart;
          const value: string = input.value;
          const variable = XmlProjectVariableDefinition.FormatTextVariable(variableName);
          const controlName = input.getAttribute('formControlName');
          const control = form.controls[controlName];
          control.patchValue(value.substring(0, selStart) + variable + value.substring(input.selectionEnd));
          selStart += variable.length;
          input.setSelectionRange(selStart, selStart);
          form.markAsDirty();
        }
        input.focus();
        return true;
      });
  }

}
